<template>
  <div class="card">
    <p class="card-header-title" v-if="title">
      {{ title }}
    </p>
    <div class="card-content">
      <slot></slot>
    </div>
    <footer class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script setup>
const props = defineProps({
    title: String,
})
</script>